import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import Logo9 from '../../images/location_new/caseimg/logo9.webp';
import Img9 from '../../images/location_new/caseimg/img9.webp';
import Logo10 from '../../images/location_new/caseimg/logo10.webp';
import Img10 from '../../images/location_new/caseimg/img10.webp';
import Logo11 from '../../images/location_new/caseimg/logo11.webp';
import Img11 from '../../images/location_new/caseimg/img11.webp';
import Logo12 from '../../images/location_new/caseimg/logo12.webp';
import Img12 from '../../images/location_new/caseimg/img12.webp';
import {Case_Arrow} from '../../../app-constants';
import {Link} from 'gatsby';

const CaseStudy = [
    {
        logo: Logo9,
        title: 'The Idea Behind Pure Plank',
        description:"Pure Plank, an online platform for health and fitness enthusiasts dedicated to maintaining well-being and exercise routines in the comfort of their homes.",
        link: 'pure-plank',
        technology: {
            iOS: 'iOS',
            Android: 'Android',
        },
        Img: Img9,
        BgColor: '#19181e66',
        TextColor: '#97f084'
    },
    {
        logo: Logo10,
        title: 'The Idea Behind Soundly',
        description:"Soundly has transformed the music experience, allowing music enthusiasts to stream millions of songs from emerging artists via the app, offering a new level of musical immersion.",
        link: 'soundly',
        technology: {
            iOS: 'iOS',
            Android: 'Android',
        },
        Img: Img10,
        BgColor: '#f79789',
        TextColor: '#ec2125'
    },
    {
        logo: Logo11,
        title: 'The Idea Behind Button Smasher App',
        description:"An All-in-One Solution for Gamers. Stay Informed with Authentic Ratings and Gaming Industry News With Button Smasher Application.",
        link: 'buttonsmasher',
        technology: {
            iOS: 'iOS',
            Android: 'Android',
        },
        Img: Img11,
        BgColor: '#6f429c80',
        TextColor: '#d8278b'
    },
    {
        logo: Logo12,
        title: 'The Idea Behind AMJ Wellness',
        description:"Workplace Wellness, a cross-platform fitness app, is designed for companies recognizing the link between employee well-being, productivity, and organizational success, fostering a healthier and more productive workforce.",
        link: 'amj-wellness',
        technology: {
            iOS: 'iOS',
            Android: 'Android',
        },
        Img: Img12,
        BgColor: '#eb374080',
        TextColor: '#c41728'
    },
];

function Stories(props) {
    return (
        <div className="section_stories p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="m-auto text-center">
                        <div className="example center text-center" data-text="Success">
                            <h2>Success Stories</h2>
                        </div>
                        <p>TekRevol has been a catalyst for numerous startups and enterprises, transforming their work processes into digitized efficiency. Our clients have witnessed remarkable business growth after adopting our fully customized software applications. Delve into our portfolio for insightful success stories</p>
                    </Col>
                    {CaseStudy.map((item, index) => (
                        <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto" key={index}>
                            <div className="stories_item" style={{backgroundColor: item.BgColor}}>
                                <div className="item_logo">
                                    <LazyLoadImage
                                        src={item.logo}
                                        effect="blur"
                                        alt={item.title}
                                        className="img-fluid"
                                    />
                                    <ul style={{color: item.TextColor, borderColor: item.TextColor}}>
                                        <li>{item.technology.iOS}</li>
                                        <li>{item.technology.Android}</li>
                                    </ul>
                                </div>
                                <div className="item_tech">
                                    <div className="tech_content">
                                        <h4 style={{color: item.TextColor}}>{item.title}</h4>
                                        <p>{item.description}</p>

                                        <Link to={item.link ? `/case-studies/${item.link}` : 'https://www.tekrevol.com/projects'}
                                              className="case_btn"
                                              aria-label="TekRevol Contact" style={{backgroundColor: item.TextColor}}>
                                            View Case Study {Case_Arrow}
                                        </Link>
                                    </div>
                                    <div className="tech_img">
                                        <LazyLoadImage
                                            src={item.Img}
                                            effect="blur"
                                            alt={item.title}
                                            className="img-fluid"
                                        />
                                    </div>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
}

export default Stories;
